define('common/js/lib/Serum.Moment',[
  'moment',
  'common/js/lib/moment/moment-nb',
  'common/js/lib/moment/moment-timezone'
], function (moment, locale, timezone) { // eslint-disable-line no-unused-vars
  'use strict';
  moment.locale('nb');
  moment.tz.setDefault('Europe/Oslo');
  return moment;
});

